import React from "react";
import Typography from "@mui/material/Typography";
import Colors from "./Colors";

function TypographySliderComponent({ onClick, sx, ...props }) {
  return (
    <Typography
      sx={{
        fontFamily: "IBM Plex Sans",
        fontWeight: 400,
        fontSize: { xs: "10px", sm: "10px", md: "20px" },
        color: sx?.color || Colors.black, // Use the color from sx if provided, otherwise default to black
        lineHeight: { xs: "12px", sm: "12px", md: "26px" },
        fontStyle: "normal",
        ...sx, // Spread the rest of sx to allow further customization
      }}
      {...props}
      onClick={onClick}
    ></Typography>
  );
}

export default TypographySliderComponent;
